import { Bars3Icon, SignalIcon, SignalSlashIcon } from '@heroicons/react/24/outline'
import { AlertsPanel } from '@/components/alerts/AlertsPanel'
import { useWebSocket } from '@/context/WebSocketContext'

interface HeaderProps {
  onMobileOpen: () => void
}

export function Header({ onMobileOpen }: HeaderProps) {
  const { isConnected, isReconnecting, error } = useWebSocket()

  return (
    <header className="h-14 flex items-center justify-between px-3 sm:px-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shrink-0">
      <button
        onClick={onMobileOpen}
        className="lg:hidden p-2 -ml-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
        aria-label="Ouvrir le menu"
      >
        <Bars3Icon className="w-6 h-6" />
      </button>
      <div className="flex-1" />
      <div className="flex items-center gap-2 sm:gap-4">
        <AlertsPanel />
        <div className="hidden sm:block h-6 w-px bg-gray-200 dark:bg-gray-700" />
        <div className="flex items-center gap-2">
          {isConnected ? (
            <>
              <SignalIcon className="w-4 h-4 text-green-500" />
              <span className="hidden sm:inline text-sm text-green-600 dark:text-green-400">Connecté</span>
            </>
          ) : isReconnecting ? (
            <>
              <SignalSlashIcon className="w-4 h-4 text-yellow-500 animate-pulse" />
              <span className="hidden sm:inline text-sm text-yellow-600 dark:text-yellow-400">Reconnexion...</span>
            </>
          ) : (
            <>
              <SignalSlashIcon className="w-4 h-4 text-red-500" />
              <span className="hidden sm:inline text-sm text-red-600 dark:text-red-400">
                {error || 'Déconnecté'}
              </span>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
